import { render, staticRenderFns } from "./HWP_Pokaz.vue?vue&type=template&id=194f5184&scoped=true&"
import script from "./HWP_Pokaz.vue?vue&type=script&lang=js&"
export * from "./HWP_Pokaz.vue?vue&type=script&lang=js&"
import style0 from "./HWP_Pokaz.vue?vue&type=style&index=0&id=194f5184&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194f5184",
  null
  
)

export default component.exports